<div
  class="modal-warning"
  [class.modal-warning--info]="variant === 'info'"
  [class.modal-warning--success]="variant === 'success'"
  [attr.data-testid]="testId || null"
>
  @if (variant === 'success') {
    <img
      class="modal-warning__icon"
      src="assets/icons/remediation-success.svg"
      alt=""
      width="28"
      height="28"
    />
  } @else {
    <span class="material-symbols-outlined modal-warning__icon">{{ icon }}</span>
  }
  <p class="modal-warning__message">
    <ng-content></ng-content>
  </p>
</div>
